module.exports = __webpack_public_path__ + "img/tui.e35034a9.png";